import { Typography } from "@mui/material";
import { BsExclamation } from "react-icons/bs";
import { MdRefresh } from "react-icons/md";
import { StyledContainer, ContentWrapper } from "./NotFound.style";

export default function NotFound(props) {
  return (
    <StyledContainer>
      <ContentWrapper elevation={8}>
        <Typography> {props.title}</Typography>
        <BsExclamation size={42} />
      </ContentWrapper>
      {props.onRefresh && <MdRefresh size={35} onClick={props.onRefresh} />}
    </StyledContainer>
  );
}
